import script from "./ThongBaoTrungTuyen.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThongBaoTrungTuyen.vue?vue&type=script&setup=true&lang=ts"

import "./ThongBaoTrungTuyen.vue?vue&type=style&index=0&id=56936696&lang=css&scoped=true"

import exportComponent from "D:\\AppV5\\DangKyXetTuyen\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56936696"]])

export default __exports__